import Axios from "axios";
import { facilityExtraPricingUrls } from "../urls";

export default {
  get_facility_extra_pricing(context, publicId) {
    Axios.get(
      facilityExtraPricingUrls.getAllFacilityExtraPricing + publicId
    )
      .then(function(response) {
        context.commit("GET_FACILITY_EXTRA_PRICING", response.data);
      })
      .catch(function() {
        context.commit("UPDATE_ERRORS", { data: [] });
      });
  },
  post_facility_extra_pricing(context, data) {
 
    Axios.post(facilityExtraPricingUrls.postFacilityExtraPricing, data)
      .then(function() {
        context.dispatch("get_facility_extra_pricing", data.facility_id);
      })
      .catch(function(error) {
        context.commit("UPDATE_ERRORS", error.data);
      });
  },
  edit_facility_extra_pricing(context, data) {
    Axios.patch(facilityExtraPricingUrls.alterFacilityExtraPricing, data).then(
      function(response) {
        context.dispatch("get_facility_extra_pricing", data.facility_id);
      }
    );
  },
  delete_a_facility_extra_pricing (context, data) {
    Axios.post(facilityExtraPricingUrls.deleteFacilityExtraPricing + data.public_id, data).then(function (response) {
      context.commit('GET_DELETED_FACILITY_EXTRA_PRICING', response.data)
    })
  },
  get_facility_commission(context, publicId) {
    Axios.get(
      facilityExtraPricingUrls.getAllFacilityCommission + publicId
    )
      .then(function(response) {
        context.commit("GET_FACILITY_COMMISSION", response.data);
      })
      .catch(function(error) {
        context.commit("UPDATE_ERRORS", { data: [] });
      });
  },
  post_facility_commission(context, data) {
    Axios.post(facilityExtraPricingUrls.postFacilityCommission, data)
      .then(function() {
        context.dispatch("get_facility_commission", data.facility_id);
      })
      .catch(function(error) {
        context.commit("UPDATE_ERRORS", error.data);
      });
  },

};
